import React, { useEffect, useState, useRef } from 'react';
import {
  Accordion,
  Tabs,
  Tab,
  Card,
  Row,
  Col,
  Container,
} from 'react-bootstrap';
import { CostCards } from './CostCards';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import Skeleton from './skeleton/GenericSkeleton';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import CustomAccordion from './CustomAccordion/CustomAccordion';
import DisabilityWatingPeriodTemplate from './CustomAccordion/DisabilityWatingPeriodTemplate';
import {
  AccordionDownArrow,
  AccordionUpArrow,
} from '../../../../img/findcare/FindCareSVG';
import MasterPermissions from '../../../../api/MasterPermissions';

const CoveredServices = (PlanInfo) => {
  const [dataFetching, setDataFetching] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [coveredservicesDetails, setCoveredservicesDetails] = useState([]);
  const [activeIds, setActiveIds] = useState([0]);
  const [loadedWaitingPeriodData, setLoadedWaitingPeriodData] = useState([]);
  const [currentActiveTab, setCurrentActiveTab] = useState('');

  const selectFirstItem = useRef();
  //JMP-65 COVERAGE COVERED COST AND SERVICES IMPLIMENTATION
  const CoverageDetailConfiguration = async (
    MasterId,
    activeCoverageType,
    skipApiCall = false,
    coverdServicesData = [],
  ) => {
    let quaryParam = '';
    if (MasterId) {
      quaryParam = 'MasterID/' + MasterId + '/product/' + activeCoverageType;
    } else {
      quaryParam = 'product/' + activeCoverageType;
    }
    setIsAPIFailed(false);
    try {
      let ServiceDetails;
      if (skipApiCall) {
        closeAllAccordions();
        ServiceDetails = coverdServicesData;
      } else {
        const CoverageDetailConfiguration = await axiosInstance.get(
          APIEndpoints.getCoverageDetailConfiguration() + quaryParam,
        );
        const CoveredServicesAndCost =
          CoverageDetailConfiguration?.data?.Response;
        ServiceDetails = CoveredServicesAndCost?.servicesjson?.Response;
      }

      setCurrentActiveTab(ServiceDetails[0]?.ServicesDetail[0]?.ServiceType);
      setCoveredservicesDetails(ServiceDetails);
      setDataFetching(false);
      setActiveIds([]);
      if (MasterPermissions.CheckPermission('View Covered Services')) {
        setTimeout(() => {
          makeFirstAccordionActive();
        }, 10);
      }
    } catch (error) {
      setActiveIds([]);
      setDataFetching(false);
      setActiveIds();
      if (error.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    }
  };

  useEffect(() => {
    //if ( PlanInfo?.currentActiveFilter !== 'benefitYear' ||PlanInfo?.currentActiveFilter !== 'network/tier' || PlanInfo?.coverageMember!== 'coverageFor' )     {
    if (PlanInfo?.MasterId || PlanInfo?.activeCoverageType) {
      setDataFetching(true);
      CoverageDetailConfiguration(
        PlanInfo?.MasterId,
        PlanInfo?.activeCoverageType,
      );
    }
    //}
  }, [
    PlanInfo?.MasterId,
    PlanInfo?.selectedUser,
    PlanInfo?.activeCoverageType,
  ]);
  useEffect(() => {
    if (PlanInfo?.selectedTier?.initialLoad === false) {
      setDataFetching(true);
      const servicesData = [...coveredservicesDetails];
      setCoveredservicesDetails([]);
      CoverageDetailConfiguration(
        PlanInfo?.MasterId,
        PlanInfo?.activeCoverageType,
        true,
        servicesData,
      );
    }
  }, [PlanInfo?.selectedTier?.value]);

  const toggleActive = (id, serviceType) => {
    if (activeIds.includes(id)) {
      const updatedIds = [...activeIds];

      updatedIds.splice(updatedIds.indexOf(id), 1);

      setActiveIds(updatedIds);
    } else {
      setCurrentActiveTab(serviceType);

      const curretnIds = [...activeIds];

      curretnIds.push(id);

      setActiveIds(curretnIds);
    }
  };

  const closeAllAccordions = () => {
    const currentActiveIds = [...activeIds];
    currentActiveIds.forEach((eachId) => {
      const element = document.querySelector('#make-me-close-' + eachId);
      element.click();
      element.dispatchEvent(new Event('click'));
    });
  };

  const makeFirstAccordionActive = () => {
    selectFirstItem.current.click();
  };

  const placeRef = (index) => {
    if (index === 0) {
      return selectFirstItem;
    } else {
      return;
    }
  };
  return (
    <>
      {isAPIFailed ? (
        <div className="px-0">
          {isNotFound || coveredservicesDetails === undefined ? (
            <></>
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
              CustomClasses="p-0"
            />
          )}
        </div>
      ) : (
        <>
          {dataFetching || coveredservicesDetails.length === 0 ? (
            <Skeleton />
          ) : (
            MasterPermissions.CheckPermission('View Covered Services') && (
              <Card className="plan-info-card">
                <Row>
                  <Col className="">
                    <h4>Covered Services and Costs</h4>
                  </Col>
                </Row>
                <Row>
                  <Col className="">
                    {/*{( PlanInfo?.activeCoverageType==='Short Term Disability'||
                 PlanInfo?.activeCoverageType==='Long Term Disability' ) ?
                 <div className="accordion">
                   { coveredservicesDetails && coveredservicesDetails.map( ( service, Index ) => (
                     <CustomAccordion
                       title={service.ServiceGroupName}
                       ServicesDetail={service.ServicesDetail}
                       MasterId={PlanInfo?.MasterId}
                       loadedWaitingPeriodData={loadedWaitingPeriodData}
                       setLoadedWaitingPeriodData={setLoadedWaitingPeriodData}
                       placeRef={placeRef}
                       indexCount={Index}
                       toggleActive={toggleActive}
                     />
                   ) )}
                 </div> : */}

                    <div>
                      {coveredservicesDetails &&
                        coveredservicesDetails.map((service, Index) => (
                          <Accordion key={Index}>
                            <>
                              {service.ServiceGroupName && (
                                <div key={Index}>
                                  <Accordion.Toggle
                                    as={Card.Header}
                                    onClick={() => {
                                      toggleActive(
                                        Index,
                                        service.ServicesDetail[0]?.ServiceType,
                                      );
                                    }}
                                    className="card-header panel-toggle text-left w-100"
                                    id={'make-me-close-' + Index}
                                    variant="link"
                                    eventKey={service.ServiceGroupName}
                                    ref={placeRef(Index)}
                                  >
                                    <span className="arrow">
                                      {activeIds !== undefined ? (
                                        activeIds.includes(Index) ? (
                                          <AccordionUpArrow className="acc-arrow" />
                                        ) : (
                                          <AccordionDownArrow className="acc-arrow" />
                                        )
                                      ) : (
                                        ''
                                      )}
                                    </span>
                                    {service.ServiceGroupName}
                                  </Accordion.Toggle>
                                  <Accordion.Collapse
                                    eventKey={service.ServiceGroupName}
                                  >
                                    <Card.Body>
                                      <Tabs
                                        onSelect={(key) => {
                                          setCurrentActiveTab(key);
                                        }}
                                      >
                                        {service.ServicesDetail.map(
                                          (serviceTabs, index) => (
                                            <Tab
                                              key={index}
                                              eventKey={serviceTabs.ServiceType}
                                              title={serviceTabs.ServiceType}
                                            >
                                              <div>
                                                {' '}
                                                {serviceTabs.ServiceDetailText}
                                                {PlanInfo?.activeCoverageType ===
                                                  'Medical' ||
                                                PlanInfo?.activeCoverageType ===
                                                  'Dental' ||
                                                PlanInfo?.activeCoverageType ===
                                                  'Vision' ||
                                                PlanInfo?.activeCoverageType ===
                                                  'Prescription' ? (
                                                  <CostCards
                                                    PlanInfo={PlanInfo}
                                                    coveredservicesDetails={
                                                      serviceTabs
                                                    }
                                                    currentActiveTab={
                                                      currentActiveTab
                                                    }
                                                    dataFetching={dataFetching}
                                                  />
                                                ) : (
                                                  <>
                                                    {PlanInfo?.activeCoverageType ===
                                                      'Short Term Disability' ||
                                                    PlanInfo?.activeCoverageType ===
                                                      'Long Term Disability' ? (
                                                      <DisabilityWatingPeriodTemplate
                                                        PlanInfo={PlanInfo}
                                                        coveredservicesDetails={
                                                          serviceTabs
                                                        }
                                                        currentActiveTab={
                                                          currentActiveTab
                                                        }
                                                      />
                                                    ) : (
                                                      <Col
                                                        md={3}
                                                        className="mb-3 mb-md-0"
                                                      >
                                                        <GenericButton
                                                          variant="secondary"
                                                          className="d-flex justify-content-center"
                                                          onClick={(event) =>
                                                            window.open(
                                                              serviceTabs?.URL,
                                                            )
                                                          }
                                                        >
                                                          View More Details
                                                        </GenericButton>
                                                      </Col>
                                                    )}
                                                  </>
                                                )}
                                              </div>
                                            </Tab>
                                          ),
                                        )}
                                      </Tabs>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </div>
                              )}
                            </>
                          </Accordion>
                        ))}
                    </div>
                  </Col>
                </Row>
              </Card>
            )
          )}
        </>
      )}
    </>
  );
};

export default CoveredServices;
